<app-header
  canvasMode="error"
  [loggedIn]="true"
  canvasType="canvasType"
  [fixedHeader]="true"
></app-header>
<div class="home-container">
  <BR /><BR />
  <div class="home-container">
    <div class="top">404 - PAGE NOT FOUND</div>
    <div class="line"></div>
    <h1>
      <p>
        404<span>THE PAGE OR REPORT YOU WERE LOOKING FOR DOES NOT EXIST</span>
      </p>
    </h1>
    <div class="bottom">
      YOU MAY HAVE MISTYPED THE ADDRESS OR THE PAGE MAY HAVE MOVED
    </div>
  </div>
</div>
